import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import { generateMediaFilename, stringFormat } from '../utils/formatting';
import {parseJSON, isOk, getUrlParams, authReq } from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/

export function ddnySetAttributes(attributes) {
	return {
		type: constants.DDNY_ATTRIBUTES,
		attributes
	};
}

export function ddnySetFilters(filters) {
	return {
		type: constants.DDNY_FILTERS,
		filters
	};
}


/******************************
*******  Asynchronous  ********
******************************/




export function ddnyFetchProductTotals(signal = null) {

	return dispatch => {

		const url = api.PRODUCT_API_URL + endpoint.PRODUCT_DDNY_PRODUCT_TOTALS;
		return fetch(url, {
			method: 'get',
			headers: authReq(api.HEADERS),
			signal,
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}


export function ddnyFetchAttributeTotals(signal = null) {

	return dispatch => {

		const url = api.PRODUCT_API_URL + endpoint.PRODUCT_DDNY_ATTRIBUTES_TOTALS;
		return fetch(url, {
			method: 'get',
			headers: authReq(api.HEADERS),
			signal,
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}


export function ddnyFetchProductBulkUpload(bulkData, signal = null) {

	return dispatch => {

		const url = api.PRODUCT_API_URL + endpoint.PRODUCT_DDNY_PRODUCT_BULK_UPLOAD;
		return fetch(url, {
			method: 'post',
			headers: authReq(api.HEADERS),
			body: JSON.stringify(bulkData),
			signal,
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}


export function ddnyFetchProductPage(filterData, signal = null) {
	return dispatch => {

		// Whether disabled products come back is decided server-side from the caller's
		// ddny admin flag; it used to be requested with an `auth=all` parameter here.
		const url = api.PRODUCT_API_URL + endpoint.PRODUCT_DDNY_PRODUCT_FILTER + getUrlParams(filterData);
		return fetch(url, {
			method: 'get',
			headers: authReq(api.HEADERS),
			signal,
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}


export function ddnyFetchAutocompletePage(filterData, signal = null) {
	return dispatch => {

		const url = api.PRODUCT_API_URL + endpoint.PRODUCT_DDNY_PRODUCT_AUTOCOMPLETE + getUrlParams(filterData);
		return fetch(url, {
			method: 'get',
			headers: authReq(api.HEADERS),
			signal,
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}


export function ddnyFetchAttributes(signal = null) {
	return dispatch => {

		const url = api.PRODUCT_API_URL + endpoint.PRODUCT_DDNY_ATTRIBUTES;
		return fetch(url, {
			method: 'get',
			headers: authReq(api.HEADERS),
			signal,
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				dispatch(ddnySetAttributes(resp.data));
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}

export function ddnyFetchProductSingle(productId, signal = null) {
	return dispatch => {

		const url = api.PRODUCT_API_URL + stringFormat(endpoint.PRODUCT_DDNY_PRODUCT_FETCH, { id: productId });
		return fetch(url, {
			method: 'get',
			headers: authReq(api.HEADERS),
			signal,
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}


export function ddnyFetchProductCreate(productData, signal = null) {

	return dispatch => {

		const url = api.PRODUCT_API_URL + endpoint.PRODUCT_DDNY_PRODUCT_CREATE;
		return fetch(url, {
			method: 'post',
			headers: authReq(api.HEADERS),
			body: JSON.stringify(productData),
			signal,
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}


export function ddnyFetchProductUpdate(productId, productData, signal = null) {

	return dispatch => {

		const url = api.PRODUCT_API_URL + stringFormat(endpoint.PRODUCT_DDNY_PRODUCT_UPDATE, { id: productId });
		return fetch(url, {
			method: 'put',
			headers: authReq(api.HEADERS),
			body: JSON.stringify(productData),
			signal,
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}


export function ddnyFetchProductDelete(productId, signal = null) {

	return dispatch => {

		const url = api.PRODUCT_API_URL + stringFormat(endpoint.PRODUCT_DDNY_PRODUCT_DELETE, { id: productId });
		return fetch(url, {
			method: 'delete',
			headers: authReq(api.HEADERS),
			body: JSON.stringify({}),
			signal,
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}


// No refresh method; should always be called via other action
export function ddnyGetMediaPostCode(productId, filename, signal = null) {
	return async (dispatch, getState) => {

		const url = api.PRODUCT_API_URL + stringFormat(endpoint.PRODUCT_DDNY_FETCH_GENERATE_POST, { 
			productId: productId,
			filename: encodeURIComponent(filename), 
		});

		return fetch(url, {
			method: 'get',
			headers: authReq(api.HEADERS),
			signal,
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}


export function ddnyUploadMedia(productId, file, signal = null) {
	return async (dispatch, getState) => {

		const codeDispatch = await ddnyGetMediaPostCode(productId, generateMediaFilename(file), signal);
		const codeResp = await codeDispatch();
		if(!codeResp) {
			return Promise.reject();
		}

		// Forward every field the presigned POST came back with instead of naming them.
		// The set varies with how the API's boto3 client was credentialed: task-role
		// credentials add x-amz-security-token, and a SigV4 region swaps AWSAccessKeyId /
		// signature for the x-amz-* family. Any field the signed policy requires and we
		// leave out is a 403 from S3.
		const formData = new FormData();
		formData.append('Content-Type', file.type || 'application/octet-stream');
		for(const [field, value] of Object.entries(codeResp.fields)) {
			formData.append(field, value);
		}
		// Must stay last: S3 ignores any form field that follows `file`.
		formData.append('file', file);

		return fetch(codeResp.url, {
			method: 'post',
			body: formData,
			signal,
		})
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve({
					key: codeResp.fields.key,
				});
			} else {
				// Reject with a shape the caller can read a message off. A bare null makes
				// `err.msg` in the catch throw, which swallows the failure entirely.
				return Promise.reject({ msg: `Upload to storage failed (${resp.status})` });
			}
		});
	}
}


export function ddnyCreateMedia(mediaData) {
	return dispatch => {

		let url = api.PRODUCT_API_URL + endpoint.PRODUCT_DDNY_CREATE_MEDIA;
		return fetch(url, {
			method: 'post',
			body: JSON.stringify(mediaData),
			headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}


export function ddnyUpdateMedia(mediaId, mediaData) {
	return dispatch => {

		let url = api.PRODUCT_API_URL + stringFormat(endpoint.PRODUCT_DDNY_UPDATE_MEDIA, { id: mediaId });
		return fetch(url, {
			method: 'put',
			body: JSON.stringify(mediaData),
			headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}


export function ddnyDeleteMedia(mediaId) {
	return dispatch => {
		let url = api.PRODUCT_API_URL + stringFormat(endpoint.PRODUCT_DDNY_DELETE_MEDIA, { id: mediaId });
		return fetch(url, {
			method: 'delete',
			body: JSON.stringify({}),
			headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}


export function ddnyUpdateVariant(updateData, variantId) {
	return dispatch => {
		const url = api.PRODUCT_API_URL + stringFormat(endpoint.PRODUCT_DDNY_UPDATE_VARIANT, { id: variantId });
		return fetch(url, {
			method: 'put',
			body: JSON.stringify(updateData),
			headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}


export function ddnyFetchProductChildData(productSku) {
	return dispatch => {

		const getData = {
			ascId: productSku,
		};

		const url = api.API_URL + endpoint.ONLINE_JEWELRY_CHILDREN + getUrlParams(getData);
		return fetch(url, {
			method: 'get',
			headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}

export function ddnyCreateVariant(variantData) {
	return dispatch => {

		let url = api.PRODUCT_API_URL + endpoint.PRODUCT_DDNY_CREATE_VARIANT;
		return fetch(url, {
			method: 'post',
			body: JSON.stringify(variantData),
			headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}

export function ddnyDeleteVariant(variantId) {
	return dispatch => {
		const url = api.PRODUCT_API_URL + stringFormat(endpoint.PRODUCT_DDNY_DELETE_VARIANT, { id: variantId });
		return fetch(url, {
			method: 'delete',
			body: JSON.stringify({}),
			headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}


export function ddnyCreateRelatedItem(relatedData) {
	return dispatch => {

		let url = api.PRODUCT_API_URL + endpoint.PRODUCT_DDNY_CREATE_RELATED_ITEM;
		return fetch(url, {
			method: 'post',
			body: JSON.stringify(relatedData),
			headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}

export function ddnyUpdateRelatedItem(relatedItemId, relatedData) {
	return dispatch => {

		const url = api.PRODUCT_API_URL + stringFormat(endpoint.PRODUCT_DDNY_UPDATE_RELATED_ITEM, { id: relatedItemId });
		return fetch(url, {
			method: 'put',
			body: JSON.stringify(relatedData),
			headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}

export function ddnyDeleteRelatedItem(relatedItemId) {
	return dispatch => {
		const url = api.PRODUCT_API_URL + stringFormat(endpoint.PRODUCT_DDNY_DELETE_RELATED_ITEM, { id: relatedItemId });
		return fetch(url, {
			method: 'delete',
			body: JSON.stringify({}),
			headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
			if(isOk(resp.status)) {
				return Promise.resolve(resp.data);
			} else {
				return Promise.reject(resp.data);
			}
		});
	}
}
